import abstractSpeedDialsProps from './abstractSpeedDialsProps';
import PropTypes from '../../_util/vue-types';
import isNumeric from '../../_util/isNumeric';
import { filterEmpty } from '../../_util/props-util';
import { ConfigConsumerProps } from '../config-provider/configConsumerProps';

const props = abstractSpeedDialsProps();

export default {
  name: 'FcSpeedDials',
  props: {
    ...props,
    prefixCls: PropTypes.string,
  },
  inject: {
    configProvider: { default: () => ConfigConsumerProps }, // 注入依赖，包含组件基本class名方法
  },
  data() {
    return {
      hideStatus: this._props.defaultHide,
      openStatus: this._props.defaultOpen,
      actionStatus: this._props.defaultOpen,
    };
  },
  watch: {},
  created() {
    // this.open;
  },
  mounted() {},
  methods: {
    /**
     *
     * @param {*} child
     * @param {*} index
     * @param {*} prefixCls
     * @returns
     */
    renderDialNode(child, index, prefixCls) {
      const { icon, title } = child.data.attrs;
      const { openStatus, setStyleOpenDials, dialClickHandler,placement } = this;
      return (
        <a-tooltip placement={(placement==='topLeft' || placement==='bottomLeft')?'right':'left'} title={title}>
        <div
          class={`${prefixCls}-dial ${this.openStatus?'':'hiddenShadow'}`}
          style={{ transform: openStatus ? 'translateY(0)' : setStyleOpenDials(index) }}
          onClick={e => dialClickHandler(e, child, index)}
        >
          <div>
            <fc-icon size="20" className={icon} />
            {/* <div class={`${prefixCls}-dial-title`}>{title}</div> */}
          </div>
        </div>
        </a-tooltip>
      );
    },
    /**
     *
     * @returns
     */
    getStyleOffset() {
      const { offsetTop, offsetBottom, placement } = this.$props;
      if (offsetTop && (placement === 'topLeft' || placement === 'topRight')) {
        return {
          top: isNumeric(offsetTop) ? `${offsetTop}px` : offsetTop,
        };
      }

      if (offsetBottom && (placement === 'bottomLeft' || placement === 'bottomRight')) {
        return {
          bottom: isNumeric(offsetBottom) ? `${offsetBottom}px` : offsetBottom,
        };
      }
    },
    /**
     * 隐藏样式
     * @param {*} prefixCls
     * @returns
     */
    setStyleHide(prefixCls) {
      const { hideStatus } = this;
      const { placement } = this._props;
      const triggerRef = this.$refs[`${prefixCls}`];
      if (hideStatus) {
        let translateX = (triggerRef.clientWidth/2 +12) || 36;
        //靠左的
        if (placement === 'topLeft' || placement === 'bottomLeft') {
          translateX = -((triggerRef.clientWidth/2 + 12) || 36);
        }
        // 默认是靠右的
        return { transform: `translateX(${translateX}px)` };
      } else {
        return { transform: `translateX(0)` };
      }
    },
    /**
     * 设置展开拨号按钮组样式
     */
    setStyleOpenDials(index) {
      const { placement } = this._props;
      const filteredChildren = filterEmpty(this.$slots.default);
      if (placement === 'topLeft' || placement === 'topRight') {
        return `translateY(-${(index + 1) * 64}px)`;
      }

      if (placement === 'bottomLeft' || placement === 'bottomRight') {
        return `translateY(${(filteredChildren.length - index) * 64}px)`;
      }
    },
    /**
     * 按钮组开关
     */
    toggleOpenHandler() {
      // 隐藏状态，禁止执行开关
      if (this.hideStatus) return;
      // 显示状态，执行开关

      // 避免按钮组空间被占用，当关闭状态，清空action的高度
      if (this.openStatus) {
        setTimeout(() => {
          this.actionStatus = this.openStatus;
        }, 200 * 2);

        this.openStatus = !this.openStatus;
        return;
      }

      this.openStatus = !this.openStatus;
      this.actionStatus = this.openStatus;
    },
    /**
     * 隐藏触发按钮
     */
    toggleHideHandler(e) {
      // 阻止事件冒泡
      e.stopPropagation();
      e.preventDefault();

      // 先关闭按钮组
      if (this.openStatus) this.openStatus = false;

      // 等待按钮组收起，在隐藏
      setTimeout(() => {
        this.hideStatus = !this.hideStatus;
      }, 200 * 2); // 开关动画执行事件为200ms
    },
    dialClickHandler(e, node, index) {
      this.$emit('click', e, node, index);
    },
  },
  render() {
    const {
      _props,
      // prefixCls: customizePrefixCls,
      hideStatus,
      actionStatus,
      toggleOpenHandler,
      toggleHideHandler,
      getStyleOffset,
      setStyleHide,
    } = this;
    const { placement, style, title, icon, type, canHide, canOpen } = _props;

    // 获取组件基本class名
    const { getPrefixCls, locale } = this.configProvider;
    const prefixCls = getPrefixCls('', 'fc-speed-dials');
    const filteredChildren = filterEmpty(this.$slots.default);

    return (
      <div
        class={`${prefixCls} ${prefixCls + '-' + placement} ${
          hideStatus ? 'hide' : 'show'
        } ${_props.className || ''}`}
        style={{ ...getStyleOffset(), ...setStyleHide(prefixCls), ...style }}
        ref={`${prefixCls}`}
      >
        <a-tooltip placement={(placement==='topLeft' || placement==='bottomLeft')?'right':'left'} title={title || locale.SpeedDials.title}>
          <div
            class={`${prefixCls}-trigger ${type ? prefixCls + '-trigger-' + type : ''} ${hideStatus?`${prefixCls}-trigger-hover`:''}`}
            onClick={canOpen && toggleOpenHandler}
          >
              <div class={`${prefixCls}-trigger-icon`}>
              {!hideStatus && <fc-icon size="20" className={icon || `FCshouyeshezhi`}></fc-icon>}
                {/* <div class={`${prefixCls}-trigger-title`}>{title || locale.SpeedDials.title}</div> */}
              </div>
            {canHide && (
              <div
                class={`${prefixCls}-trigger-hide ${(placement === 'topRight' ||
                  placement === 'bottomRight') &&
                  hideStatus &&
                  'placement-right'} ${hideStatus?`${prefixCls}-trigger-hide-show`:''}`}
                  style={hideStatus?`transform:translate(${(placement==='topLeft' || placement==='bottomLeft')?'8px':'-13px'},-18.5px);`:''}
                onClick={canHide && toggleHideHandler}
              >
                <fc-icon size="20" className={hideStatus ? (`${(placement==='topLeft' || placement==='bottomLeft')?'FCarrow-right-double':'FCarrow-left-double'}`) : 'FCjianhao-4'}></fc-icon>
              </div>
            )}
          </div>
        </a-tooltip>

        <div class={`${prefixCls}-action`}>
          {/* 标签直接渲染 */}
          {actionStatus &&
            filteredChildren.map((child, index) => {
              return this.renderDialNode(child, index, prefixCls);
            })}
        </div>
      </div>
    );
  },
};
